export default __webpack_public_path__ + "static/media/Closure-of-Trading-Window.25db0811.pdf";